import { render } from "./VoucherGiftHistory.vue?vue&type=template&id=5dbe5230&scoped=true"
import script from "./VoucherGiftHistory.vue?vue&type=script&lang=js"
export * from "./VoucherGiftHistory.vue?vue&type=script&lang=js"

import "./VoucherGiftHistory.vue?vue&type=style&index=0&id=5dbe5230&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbe5230"]])

export default __exports__